import baseAPI from '@/api/baseAPI'
import { saveAs } from 'file-saver'

class StudentsAPI extends baseAPI {
  get entity() {
    return {
      route: `/students`,
      name: 'طالب'
    }
  }

  getAllFiltered(data){
    return new Promise((resolve, reject) => {
      return this.request.get(`${this.entity.route}`, {params: data})
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  deleteMulti(ids){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/delete`, {ids})
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  export() {
    return new Promise((resolve, reject) => {
      return this.request.get(`${this.entity.route}/export`, {responseType: 'blob'})
        .then(response => {
          saveAs(new Blob([response.data]), 'قائمة الطلبة.xlsx')
          resolve(this.responseWrapper(response))
        })
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  addCourse(id, course_id, course_group) {
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/${id}/courses/${course_id}/${course_group}`)
        .then(response => {resolve(this.responseWrapper(response))})
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  deleteCourse(id, course_id, course_group) {
    return new Promise((resolve, reject) => {
      return this.request.delete(`${this.entity.route}/${id}/courses/${course_id}/${course_group}`)
        .then(response => {resolve(this.responseWrapper(response))})
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new StudentsAPI()
